import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { axiosInstance } from 'api/axios-instance';
import { newClients } from 'types/new-clients';

export interface DocumentsListParams extends PaginatedRequestParams {
  Name?: string;
  Email?: string;
  PhoneNumber?: string;
  retry?: boolean;
  created_at_from?: string; // ISO8601_FORMAT
  created_at_to?: string; // ISO8601_FORMAT
}
export type fetchFalg = {
  Flag: string;
};
export type DocumentResponse = PaginatedResponse<newClients>;

export const DocumentsApiService = () => {
  // const createDocuments = async (formData: FormData) => {
  //   const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
  //   const response = await axiosInstance.post(
  //     `${baseURL}/ClientDocuments/UploadDocuments`,
  //     formData,
  //     {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     },
  //   );

  //   return response.data;
  // };
  const createDocuments = async (payload: any) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      endpoint: `${baseURL}/ClientDocuments/UploadDocuments`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const getCategory = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<DocumentResponse>({
      ...callConfig,
      endpoint: `${baseURL}/Master/GetCategory`,
      params,
    });

    return response.data;
  };
  const dropDownByFlag = async (
    Flag: any,
    ParentId: any, // Pass ParentId as a parameter
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<DocumentResponse>({
      ...callConfig,
      endpoint: `${baseURL}/Dropdown/Get?Flag=${Flag}&ParentId=${ParentId}`,
    });

    return response;
  };
  const getCustomizeAccess = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<DocumentResponse>({
      ...callConfig,
      endpoint: `/Client/GetClientServices`,
      params,
    });

    return response.data;
  };
  const getDocumentList = async (
    CompanyId?: string, // Make CompanyId optional
    callConfig?: Partial<ApiClientConfig>,
  ): Promise<DocumentResponse | null> => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<DocumentResponse>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientAssignedServices?CompanyId=${CompanyId}`,
    });

    return response.data; // Assuming the API returns data in the response
  };
  const getAssignedDocument = async (
    params: any, // Include pagination parameters
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientAssignedServices`,
      params,
    });

    return response.data;
  };
  const getDocumentPendingList = async (
    CompanyId?: string, // Make CompanyId optional
    callConfig?: Partial<ApiClientConfig>,
  ): Promise<DocumentResponse | null> => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<DocumentResponse>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientDocumentList?CompanyId=${CompanyId}`,
    });

    return response.data; // Assuming the API returns data in the response
  };
  const getDocumentCategoryPendingList = async (
    params?: any, // Make CompanyId optional
    callConfig?: Partial<ApiClientConfig>,
  ): Promise<DocumentResponse | null> => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<DocumentResponse>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientDocumentList`,
      params,
    });

    return response.data; // Assuming the API returns data in the response
  };
  const getRequestDocument = async (
    params: any, // Include pagination parameters
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetAdminRequestedClientDocumentList`,
      params,
    });

    return response.data;
  };
  const getRejectedDocument = async (
    params: any, // Include pagination parameters
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientDocumentList`,
      params,
    });

    return response.data;
  };

  // const UploadDocuments = async (formData: FormData) => {
  //   const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
  //   const response = await axiosInstance.post(
  //     `${baseURL}/ClientDocuments/UploadDocuments`,
  //     formData,
  //     {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     },
  //   );

  //   return response.data;
  // };
  const UploadDocuments = async (payload: any) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      endpoint: `${baseURL}/ClientDocuments/UploadDocuments`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const getAttentionDocument = async (
    params: any, // Include pagination parameters
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientAttentionRequiredDocumentList`,
      params,
    });

    return response.data;
  };
  const getCommentsList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<DocumentResponse>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetClientDocumentDetails`,
      params,
    });

    return response.data;
  };
  const AddComments = async (formData: FormData) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL}/ClientDocuments/AddDocumentComment`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  const dropDownByClassFlag = async (
    params: any, // Pass ParentId as a parameter
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/Dropdown/Get`,
      params,
    });

    return response;
  };
  const DocumentsCountValue = async (payload: any) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      endpoint: `${baseURL}/ClientDocuments/GetCompanyDocumentTypeCount`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const DocumentsLink = async (formData: FormData) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await axiosInstance.post(
      `${baseURL}/ClientDocuments/UploadRequestedDocumentsByLink`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };
  // const DocumentsUniversalLink = async (formData: FormData) => {
  //   const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
  //   const response = await axiosInstance.post(
  //     `${baseURL}/ClientDocuments/UploadDocumentsByUnversalLink`,
  //     formData,
  //     {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     },
  //   );

  //   return response.data;
  // };
  const DocumentsUniversalLink = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/UploadDocumentsByUnversalLink`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const getMarkFinished = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetMarkAsFinished`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const getMarkFinishedUniversal = async (
    payload: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_PARTNERPLUS_API_CLIENT_BASE_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/ClientDocuments/GetUploadDocumentMarkAsFinished`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  return {
    getCategory,
    createDocuments,
    dropDownByFlag,
    getCustomizeAccess,
    getDocumentList,
    getRequestDocument,
    getDocumentPendingList,
    getRejectedDocument,
    UploadDocuments,
    getAttentionDocument,
    getCommentsList,
    AddComments,
    dropDownByClassFlag,
    getAssignedDocument,
    getDocumentCategoryPendingList,
    DocumentsCountValue,
    DocumentsLink,
    getMarkFinished,
    DocumentsUniversalLink,
    getMarkFinishedUniversal,
  };
};
